__turbopack_context__.v({
  "accordionSlideOverwrite": "button-module-scss-module__v0WLza__accordionSlideOverwrite",
  "button": "button-module-scss-module__v0WLza__button",
  "destructive": "button-module-scss-module__v0WLza__destructive",
  "endIcon": "button-module-scss-module__v0WLza__endIcon",
  "fadeIn": "button-module-scss-module__v0WLza__fadeIn",
  "fadeOut": "button-module-scss-module__v0WLza__fadeOut",
  "ghost": "button-module-scss-module__v0WLza__ghost",
  "icon": "button-module-scss-module__v0WLza__icon",
  "iconSmall": "button-module-scss-module__v0WLza__iconSmall",
  "large": "button-module-scss-module__v0WLza__large",
  "loading": "button-module-scss-module__v0WLza__loading",
  "loadingText": "button-module-scss-module__v0WLza__loadingText",
  "medium": "button-module-scss-module__v0WLza__medium",
  "mini": "button-module-scss-module__v0WLza__mini",
  "neutral": "button-module-scss-module__v0WLza__neutral",
  "primary": "button-module-scss-module__v0WLza__primary",
  "scaleIn": "button-module-scss-module__v0WLza__scaleIn",
  "scaleOut": "button-module-scss-module__v0WLza__scaleOut",
  "secondary": "button-module-scss-module__v0WLza__secondary",
  "small": "button-module-scss-module__v0WLza__small",
  "spinner": "button-module-scss-module__v0WLza__spinner",
  "startIcon": "button-module-scss-module__v0WLza__startIcon",
  "tertiary": "button-module-scss-module__v0WLza__tertiary",
  "tiny": "button-module-scss-module__v0WLza__tiny",
  "withIcon": "button-module-scss-module__v0WLza__withIcon",
  "zoomIn": "button-module-scss-module__v0WLza__zoomIn",
  "zoomOut": "button-module-scss-module__v0WLza__zoomOut",
});
